import { motion } from "framer-motion";

const INSTAGRAM_HANDLE = "eurosteelnz";
const INSTAGRAM_URL = `https://www.instagram.com/${INSTAGRAM_HANDLE}`;
const LIGHTWIDGET_IFRAME =
  "https://cdn.lightwidget.com/widgets/710f3a52907d5743aa5c233637e19b96.html";

export const ProductsGrid = () => {
  return (
    <section
      id="collection"
      data-testid="instagram-feed"
      className="relative z-10 border-t border-black/5 bg-[#f5f3ee] py-14 lg:py-20"
    >
      <div className="mx-auto max-w-[1600px] px-6 lg:px-16">
        {/* Header */}
        <div className="flex flex-col items-center gap-2 text-center">
          <motion.a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
            data-testid="instagram-follow-cta"
            className="font-serif-display text-3xl font-bold uppercase leading-[1.05] tracking-[-0.01em] text-black transition-colors duration-500 hover:text-[#c6a87c] lg:text-5xl"
          >
            Follow Us
          </motion.a>
          <motion.a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.19, 1, 0.22, 1] }}
            data-testid="instagram-feed-heading"
            className="font-tech text-xs uppercase tracking-[0.35em] text-black/60 underline-offset-4 transition-colors duration-500 hover:text-[#c6a87c] hover:underline"
          >
            @{INSTAGRAM_HANDLE}
          </motion.a>
        </div>

        {/* Live LightWidget embed of the real @eurosteelnz feed — square
            container so all 9 tiles (3x3) are always visible on any viewport. */}
        <div
          data-testid="instagram-lightwidget"
          className="mx-auto mt-8 aspect-square w-full max-w-[960px] overflow-hidden rounded-2xl border border-black/10 bg-white p-2 lg:mt-10 lg:p-3"
        >
          <iframe
            title="Eurosteel Instagram feed"
            src={LIGHTWIDGET_IFRAME}
            scrolling="no"
            style={{ width: "100%", height: "100%", border: 0, overflow: "hidden" }}
          />
        </div>
      </div>
    </section>
  );
};
